/**
 * Calculate total hours from availability slots.
 * Morning/Afternoon/Evening shifts = 6 hours, Day/Night shifts = 12 hours.
 *
 * Shift types are matched case-insensitively: the review agent emits them
 * lowercase, while tools upload them capitalised ('Morning', 'Afternoon'), and
 * both must land on the same number of hours.
 *
 * @param availabilityData - The availability data object containing slots
 * @returns Total hours calculated from all availability slots
 */
export function calculateAvailabilityHours(
  availabilityData: Record<string, unknown> | null | undefined,
): number {
  if (!availabilityData?.availability_slots) return 0;

  const slots = availabilityData.availability_slots;
  if (!Array.isArray(slots)) return 0;

  // Calculate hours based on shift type
  return slots.reduce((total, slot: unknown) => {
    const rawShiftType =
      slot && typeof slot === 'object' && 'shift_type' in slot
        ? (slot as { shift_type: string }).shift_type
        : undefined;
    const shiftType = typeof rawShiftType === 'string' ? rawShiftType.trim().toLowerCase() : '';
    if (shiftType === 'morning' || shiftType === 'afternoon' || shiftType === 'evening') {
      return total + 6; // Morning/Afternoon/Evening shifts are 6 hours
    } else if (shiftType === 'day' || shiftType === 'night') {
      return total + 12; // Day/Night shifts are 12 hours
    }
    return total + 12; // Default to 12 hours for unknown shift types
  }, 0);
}
